import { lazy } from "react";
import IRoute from "./IRoute";

const UserDetailsPage = lazy(() => import("../pages/Users/UserDetailsPage"));

const usersRoutes: IRoute = {
  path: "/users",
  redirect: "/standings/view",
  children: [
    {
      path: "/:userName",
      component: UserDetailsPage,
      needAuth: true,
    },
  ],
};

export default usersRoutes;
